/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: index.js
 * Created by: chan.ying
 * Create Date: 2026-04-27 15:59
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import ValidateUtil from "./validate/index";

// eslint-disable-next-line no-unused-vars
const install = function (Vue) {
    Vue.$ValidateUtil = ValidateUtil
}

export default {
    install
}